(() => {
  const galleries = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (galleries.has(gallery)) return;
      const track = gallery.querySelector('.tm-gallery-track');
      const slides = [...track.children];
      const counter = gallery.querySelector('[data-counter]');
      if (!slides.length) return;
      let current = 0;
      const leftFor = slide => slide.offsetLeft - track.offsetLeft;
      const show = (index, animate = true) => {
        current = (index + slides.length) % slides.length;
        track.scrollTo({left: leftFor(slides[current]), behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
        if (counter) counter.textContent = String(current + 1);
      };
      const selectImage = (imageId, animate = true) => {
        const index = slides.findIndex(slide => slide.dataset.imageId === imageId);
        if (index >= 0) show(index, animate);
      };
      gallery.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.direction))));
      track.addEventListener('scroll', () => {
        let nearest = 0;
        slides.forEach((slide, index) => {if (Math.abs(leftFor(slide) - track.scrollLeft) < Math.abs(leftFor(slides[nearest]) - track.scrollLeft)) nearest = index;});
        current = nearest;
        if (counter) counter.textContent = String(current + 1);
      }, {passive: true});
      galleries.set(gallery, {selectImage});
      selectImage(gallery.dataset.selectedImage, false);
    });
    root.querySelectorAll('[data-product]').forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const select = product.querySelector('[data-variant]');
      const price = product.querySelector('[data-price]');
      const add = product.querySelector('[data-add]');
      const gallery = product.closest('[data-product-section]')?.querySelector('[data-gallery]');
      if (!select) return;
      const update = (animate = true) => {
        const variant = select.selectedOptions[0];
        const available = variant.dataset.available === 'true';
        if (price) price.textContent = variant.dataset.price;
        if (add) {add.hidden = false; add.disabled = !available;}
        const consult = product.querySelector('[data-consult]');
        if (consult) consult.hidden = available;
        const note = product.querySelector('[data-stock-note]');
        if (note) note.hidden = available;
        galleries.get(gallery)?.selectImage(variant.dataset.imageId, animate);
      };
      select.addEventListener('change', () => {update(); const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url);});
      update(false);
    });
    root.querySelectorAll('[data-pack-builder]').forEach(builder => {
      if (builder.dataset.initialized) return;
      builder.dataset.initialized = 'true';
      const kind = builder.querySelector('[data-pack-kind]');
      const groups = [...builder.querySelectorAll('[data-pack-group]')];
      const updatePack = () => {
        const choice = kind.selectedOptions[0];
        groups.forEach(group => {
          const active = group.dataset.packGroup === choice.dataset.kind;
          group.hidden = !active;
          const fields = [...group.querySelectorAll('[data-pack-choice]')];
          const counts = new Map();
          fields.forEach(field => {
            field.disabled = !active;
            field.setCustomValidity('');
            const option = field.selectedOptions[0];
            const photo = field.closest('.tm-pack-option').querySelector('[data-pack-photo]');
            photo.hidden = !option?.dataset.photo;
            if (option?.dataset.photo) {photo.src = option.dataset.photo; photo.alt = option.textContent.trim();}
            if (active && option?.dataset.key) counts.set(option.dataset.key, (counts.get(option.dataset.key) || 0) + 1);
          });
          if (active) fields.forEach(field => {
            const option = field.selectedOptions[0];
            if (option?.dataset.key && counts.get(option.dataset.key) > Number(option.dataset.max)) field.setCustomValidity('Este lote tiene menos piezas que las que elegiste. Combina otro diseño.');
          });
        });
        const amount = Number(choice.dataset.price);
        builder.querySelector('[data-pack-total]').textContent = new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(amount) + ' COP';
        builder.querySelector('[data-pack-total-value]').value = amount;
      };
      builder.addEventListener('change', updatePack);
      updatePack();
    });
    root.querySelectorAll('[data-order-request]').forEach(request => {
      if (request.querySelector('[data-request-success], [data-request-errors]')) request.open = true;
    });
    root.querySelectorAll('.tm-cart').forEach(cart => {
      if (cart.dataset.requestInitialized) return;
      cart.dataset.requestInitialized = 'true';
      const quantities = [...cart.querySelectorAll('[name="updates[]"]')];
      const request = cart.querySelector('[data-order-request]');
      quantities.forEach(input => input.addEventListener('input', () => {
        const changed = quantities.some(field => field.value !== field.defaultValue);
        if (request) request.hidden = changed;
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();



